import {
  getSinistreApi,
  getSinistreDetailsApi,
  getRefundsAMCApi,
  getDetailRefundAMCApi,
} from 'store/sinistre/api';
import {
  getSinistreDetailsFailed,
  getSinistresFailed,
  setSinistreDetails,
  setSinistres,
  setRefundsAMC,
  getRefundsAMCFailed,
  setRefundAMCDetails,
  getRefundAMCDetailsFailed,
} from 'store/sinistre/actions';
import {
  GET_SINISTRES,
  GET_SINISTRE_DETAILS,
  GET_REFUNDS_AMC,
  GET_REFUND_AMC_DETAILS,
} from 'store/sinistre/constants';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { get } from 'lodash';

export function* getSinistres() {
  try {
    const language = yield select(getLocaleSelector);
    const { data: response } = yield call(getSinistreApi, {
      language,
    });
    if (response.success) {
      yield put(setSinistres(response.data));
    } else {
      yield put(getSinistresFailed());
    }
  } catch {
    yield put(getSinistresFailed());
  }
}
export function* watchGetSinistres() {
  yield takeLatest(GET_SINISTRES, getSinistres);
}

export function* getSinistreDetails(payload: any) {
  try {
    const language = yield select(getLocaleSelector);
    const { data: response } = yield call(getSinistreDetailsApi, {
      language,
      claimNumber: payload.claimNumber,
    });
    if (response.success) {
      yield put(setSinistreDetails(response.data.timeline));
    } else {
      yield put(getSinistreDetailsFailed());
    }
  } catch (err) {
    if (err.message === 'Request failed with status code 404')
      return yield put(setSinistreDetails([]));
    yield put(getSinistreDetailsFailed());
  }
}

export function* watchGetSinistreDetails() {
  yield takeLatest(GET_SINISTRE_DETAILS, getSinistreDetails);
}

export function* getRefundsAMCSaga(payload: any) {
  const { page = null, perPage = null } = payload;
  try {
    const response = yield call(getRefundsAMCApi, { page, perPage });
    const formatedResponse = get(response, 'data', {});
    const refunds = get(formatedResponse.data, 'items', {});
    if (formatedResponse.success) {
      yield put(setRefundsAMC(refunds));
    }
  } catch (error) {
    yield put(getRefundsAMCFailed(error));
  }
}

export function* watchGetRefundsAMCSaga() {
  yield takeLatest(GET_REFUNDS_AMC, getRefundsAMCSaga);
}

export function* getRefundAmcDetails(payload: any) {
  try {
    const response = yield call(getDetailRefundAMCApi, payload);
    if (response.data.success) {
      yield put(setRefundAMCDetails(response.data));
    } else {
      yield put(getRefundAMCDetailsFailed(payload));
    }
  } catch (err) {
    if (err.message === 'Request failed with status code 404')
      return yield put(setRefundAMCDetails({}));
    yield put(getRefundAMCDetailsFailed(err));
  }
}

export function* watchGetRefundAMCDetails() {
  yield takeLatest(GET_REFUND_AMC_DETAILS, getRefundAmcDetails);
}

export default [
  watchGetSinistres,
  watchGetSinistreDetails,
  watchGetRefundsAMCSaga,
  watchGetRefundAMCDetails,
];
